package models

import kotlinx.serialization.Serializable

@Serializable
data class PersonDetails(
    val id: Int,
    val name: String? = null,
    val biography: String? = null,
    val birthday: String? = null,
    val deathday: String? = null,
    val placeOfBirth: String? = null,
    val profilePath: String? = null,
    val knownForDepartment: String? = null,
    val filmography: List<VideoDetails> = emptyList(),
)

@Serializable
data class PersonPreview(
    val id: Int,
    val name: String? = null,
    val profilePath: String? = null,
    val knownForDepartment: String? = null,
)
